import FetchService from "./Shared/FetchService";
import PersonAchievementDomainService from "../Domain/PersonAchievement/PersonAchievement.service";
const baseURL = "/aviso/achievement";
export default class AchievementService {
    static search(query, max = 20, offset = 0, active = null) {
        return FetchService.getPagedResponse(baseURL + "/search", {
            active,
            query,
            max,
            offset,
        });
    }
    static getPersonAchievement(personAchievementId) {
        return FetchService.getSingleResponse(baseURL + "/getPersonAchievement", {
            personAchievementId,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => PersonAchievement' is not assignable to parameter of type '(value: unknown) => PersonAchievement | PromiseLike<PersonAchievement>'.
        }).then(PersonAchievementDomainService.fromJSON);
    }
}
